{
  "version": 1,
  "asset_id": "1a485d1c-f203-4fa6-ae7f-020363ddf34f",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/1a485d1c-f203-4fa6-ae7f-020363ddf34f/golden-lotus-preview.wav",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/1a485d1c-f203-4fa6-ae7f-020363ddf34f/golden-lotus-preview.wav",
  "original_filename": "golden-lotus-preview.wav",
  "size": 29495344,
  "content_type": "audio/wav",
  "created_at": "2026-07-15T00:43:46Z"
}
